module.exports = __webpack_public_path__ + "img/mission.98583d27.jpg";